import { useEffect, useState } from "react";
import { Button } from "../../../../core/components/atoms/Button";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";
import { IRevision } from "../../../../core/models/essay";
import { format } from "date-fns";

interface IModalHistory {
  isOpen: boolean;
  onClose: () => void;
  history: IRevision[];
  correctionAt: Date;
}

export default function ModalHistory({ history, isOpen, onClose, correctionAt }: IModalHistory) {
  const [historyArray, setHistoryArray] = useState<{type: string, date: Date | string}[]>([]);

  useEffect(() => {
    if(history && correctionAt) {
      const historyArray: { type: string, date: Date | string }[] = [];

      history.map((it) => {
        if(it.isRevision) {
          historyArray.push({ type: 'Revisão', date: it.revisionAt || new Date() });
        } else {
          historyArray.push({ type: 'Correção', date: it.payload.corrigida_em});  
        }
      })
      
      setHistoryArray(historyArray);
    }
  }, [history])
  
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position="center"
      className="p-0 w-2/6"
    >
      <div className="flex flex-col gap-xl">
        {historyArray.map((it, i) => (
          <div key={i} className="flex flex-row justify-between items-center">
            <Typography weight="bold">
              {it.type === 'Correção' ? 'Correção' : 'Recorreção disponível'}
            </Typography>
            <Typography>
              {format(new Date(it.date), 'dd/MM/yyyy')} às {format(new Date(it.date), 'HH:mm')}
            </Typography>
          </div>
        ))}
          
        <div className="flex f1lex-row items-center justify-end gap-sm">
          <Button variant="text" onClick={() => onClose()}>
            Fechar
          </Button>
        </div>
      </div>
    </Modal>
  )
}